import React from "react";
import { Box, TablePagination, Pagination } from "@mui/material";
import ChevronDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { COLORS } from "../themes/Base";
import useSharedStyles from "../styles/Shared";

type StickyPaginationProps = {
  count: number;
  page: number; // 1-based
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  rowsPerPageOptions?: number[];
  sx?: object;
};

const StickyPagination: React.FC<StickyPaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [50, 100],
  sx = {},
}) => {
  const { classes } = useSharedStyles();
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        width: "calc(100% - 76px)",
        position: "fixed",
        bottom: 0,
        padding: "16px 24px",
        bgcolor: "#FEFFF8",
        borderTop: `1px solid ${COLORS.inputBorder}`,
        zIndex: (theme) => theme.zIndex.appBar,
        ...sx,
      }}
      className={classes.pagination}
    >
      <TablePagination
        sx={{ fontSize: 14 }}
        component="div"
        count={count}
        page={page - 1}
        onPageChange={(_, p) => onPageChange(p + 1)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => onRowsPerPageChange(Number(e.target.value))}
        rowsPerPageOptions={rowsPerPageOptions}
        labelRowsPerPage="Rows per page"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
        ActionsComponent={() => null}
        slotProps={{
          select: {
            IconComponent: () => <ChevronDownIcon sx={{ color: "#67676C" }} />,
            sx: {
              fontSize: 14,
              background: "#F8F8F9",
              borderRadius: "8px",
              border: "1px solid #E0E0E4",
              px: "16px",
              py: 0,
              height: 40,
              '& .MuiSelect-select.MuiTablePagination-select.MuiInputBase-input': {
                paddingRight: 1,
                fontSize: 14,
                paddingLeft: 0,
                background: "transparent",
              },
              '& fieldset': {
                border: "none",
              },
            },
            MenuProps: {
              PaperProps: {
                sx: {
                  borderRadius: "8px",
                  "& .MuiMenuItem-root": {
                    fontSize: 14,
                  },
                },
              },
            },
          },
        }}
      />
      <Pagination
        size="small"
        count={Math.ceil(count / rowsPerPage)}
        page={page}
        onChange={(_, p) => onPageChange(p)}
        sx={{ fontSize: 14, marginRight: "24px" }}
      />
    </Box>
  )
};

export default StickyPagination;
